import axios from "axios";
import { loadAuthState } from "../store/actions/auth";
import { getDefaultLanguage } from "../store/actions/ui";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_SERVICE_URL}`,
});

axiosInstance.interceptors.request.use((config) => {
  // Retrieve token from localStorage
  const { token } = loadAuthState();

  // If token is found
  if (token) {
    // Get request headers and if headers is undefined assign blank object
    // @ts-ignore
    config.headers = config.headers || {};

    // Set authorization header
    // ℹ️ JSON.parse will convert token to string
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers.Language = getDefaultLanguage();
  }

  // Return modified config
  return config;
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // Reject the promise with the error for further handling if needed
    return Promise.reject(error);
  }
);

export const axiosException = (e) => {
  if (e.status === 401 && 
    window.location.pathname !== "/login" &&
    window.location.pathname !== "/admin-login") {
    localStorage.removeItem("auth");
    window.location.href = "/login";
  }

  return {
    status: "fail",
    message: e.response?.data?.message || e.message,
    data: null,
  };
};

export default axiosInstance;
